import { render, staticRenderFns } from "./SimplifiedHeader.vue?vue&type=template&id=0b3e7cf2&"
import script from "./SimplifiedHeader.vue?vue&type=script&lang=js&"
export * from "./SimplifiedHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports